const attendeeReportOrder = [
  'client',
  'clientId',
  'payceEventId',
  'clientEventId',
  'payceEventAttendeeId',
  'clientAttendeeId',
  'currentStatus',
  'serviceConfirmed',
  'invoicesSubmitted',
  'eventName',
  'startDate',
  'endDate',
  'meetingOrganiserEmailAddress',
  'paymentApproverEmailAddress',
  'serviceProviderName',
  'serviceProviderEmailAddress',
  'payeeName',
  'eventTypeName',
  'contractedFee',
  'feeTotal',
  'confirmedFee',
  'expensesTotal',
  'vatValue',
  'totalPayment',
  'currencyCode',
  'paymentInstalment',
  'expensesAllowable',
  'invoiceRequired',
  'blockPaymentResult',
  'hasNotes',
];

const paymentReportOrder = [
  'clientId',
  'client',
  'clientDomain',
  'payceEventId',
  'clientEventId',
  'payceAttendeeId',
  'clientAttendeeId',
  'datePaidUtc',
  'paymentYear',
  'eventName',
  'firstName',
  'lastName',
  'serviceOrgName',
  'email',
  'externalDataSourceId',
  'payeeAccountType',
  'attendeeType',
  'attendeeSubtype',
  'consentStatus',
  'fees',
  'expensesForService',
  'registrationFees',
  'expensesForAttending',
  'sponsorship',
  'grantsAndDonations',
  'vat',
  'incomeTax',
  'total',
  'currencyCode',
  'countryCode',
  'externalTOV',
];

export class ExportOrdering {
  constructor(reportType) {
    this.reportType = reportType;
      this.order = reportType === 0 ? attendeeReportOrder : paymentReportOrder;
  }

  getOrder() {
    return this.order;
  }

  setReportType(reportType) {
    this.reportType = reportType;
      this.order = reportType === 0 ? attendeeReportOrder : paymentReportOrder;
  }
}

export const getExportOrder = (reportType) => {
  const ordering = new ExportOrdering(reportType);
  return ordering.getOrder();
};

export { attendeeReportOrder, paymentReportOrder };
